import { ChevronDownSmall as IconComponent } from '@adobe/react-spectrum-ui/dist/ChevronDownSmall.js';
import { UIIcon } from '@adobe/react-spectrum/private/icon/UIIcon';
import React from 'react';
export default function ChevronDownSmall(props) {
  return /*#__PURE__*/React.createElement(UIIcon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}